import getImage from "./GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import htmlToPdfmake from "html-to-pdfmake";
import { calculateAgeParse } from "../../../../Utils/Patient";
import ReportsAPI from "./../../../../Reports/api/reports_api";
import {
  validateProcessECO,
  validateFromHCProcessStress,
  validateFromHCProcessTest,
  validateFromHCProcessEKG,
  validateFromHCProcessHolter,
  validateFromHCProcessMap,
  validateFromHCProcessECO,
} from "../../../../Utils/UtilOtherProcedures";

const proceduresAndMedicinesPDF = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };
  console.log("ComingToPDFTODOS", data);
  const { nombres, apellido1, apellido2, reg_medico, especialidad } =
    data.professional;
  let esp = especialidad !== undefined ? especialidad : "";
  let body_formula = [];
  let docContent = [];

  const fecha = moment(data.today).format("DD-MM-YYYY h:mm");
  const name =
    data.typeOfDocument + "-" + data.documentNumber + " " + data.names;

  const city = data.profile.direccion.id_ciudad;
  const dept = data.profile.direccion.id_dpto;
  const getCity = await ReportsAPI.loadCity(city);
  const getDepts = await ReportsAPI.loadDepartment();
  const deptoProfile = getDepts.find((depto) => depto.id === dept);
  console.log("location", getCity, deptoProfile);

  /* const tableOldPathological = [
        [
            { text: "Antecedentes personales ", style: "tableheader" },
            "",
            "",
        ],
        [{ text: "Patologicos: ", bold: true, fontSize: 10 }, "", ""],
        [
            { text: "HIPERTENSIÓN -", style: "textStyle" },
            { text: !!hipertension ? hipertension.value : '', style: "textStyle" },
            { text: !!hipertension ? hipertension.commentary : '', style: "textStyle" },
        ],
        [
            { text: "METÁBOLICOS -", style: "textStyle" },
            { text: !!metabolicos ? metabolicos.value : '', style: "textStyle" },
            { text: !!metabolicos ? metabolicos.commentary : '', style: "textStyle" }
        ],
        [
            { text: "CARDIACOS -", style: "textStyle" },
            { text: !!cardiacos ? cardiacos.value : '', style: "textStyle" },
            { text: !!cardiacos ? cardiacos.commentary : '', style: "textStyle" },
        ],
        [
            { text: "INFECCIOSOS", style: "textStyle" },
            { text: !!infecciosos ? infecciosos.value : '', style: "textStyle" },
            { text: !!infecciosos ? infecciosos.commentary : '', style: "textStyle" }
        ],
        [
            { text: "VASCULARES -", style: "textStyle" },
            { text: !!vasculares ? vasculares.value : '', style: "textStyle" },
            { text: !!vasculares ? vasculares.commentary : '', style: "textStyle" }
        ],
        [
            { text: "ALÉRGICOS -", style: "textStyle" },
            { text: !!alergicos ? alergicos.value : '', style: "textStyle" },
            { text: !!alergicos ? alergicos.commentary : '', style: "textStyle" }
        ],
        [
            { text: "CANCER -", style: "textStyle" },
            { text: !!cancer ? cancer.value : '', style: "textStyle" },
            { text: !!cancer ? cancer.commentary : '', style: "textStyle" }
        ],
        [
            { text: "TRANSFUSIONES -", style: "textStyle" },
            { text: !!transfusiones ? transfusiones.value : '', style: "textStyle" },
            { text: !!transfusiones ? transfusiones.commentary : '', style: "textStyle" }
        ],
        [
            { text: "AUTOINMUNES -", style: "textStyle" },
            { text: !!autoinmunes ? autoinmunes.value : '', style: "textStyle" },
            { text: !!autoinmunes ? autoinmunes.commentary : '', style: "textStyle" }
        ],
        [
            { text: "TRAUMÁTICO -", style: "textStyle" },
            { text: !!traumatico ? traumatico.value : '', style: "textStyle" },
            { text: !!traumatico ? traumatico.commentary : '', style: "textStyle" }
        ],
    ] */

  const format_today = moment(data.infoAdmission?.admision?.fecha).format(
    "DD [de] MMMM [de] YYYY"
  );

  let urlServe =
    process.env.REACT_APP_PUBLIC_URL +
    "profesional/ver-firma/" +
    data.id_profesional +
    "/" +
    sessionStorage.getItem("token");
  let urlFirma = "";
  //let urlServe = process.env.REACT_APP_PUBLIC_URL+  'profesional/ver-firma/11/' +   sessionStorage.getItem('token');
  //console.log(urlFirma);
  let test = fetch(urlServe).then((response) => {
    if (response.status === 500) {
      return false;
    } else {
      return true;
    }
  });

  let isImg = await test;

  if (isImg) {
    urlFirma = urlServe;
  } else {
    urlFirma = "https://i.postimg.cc/0jznYVsr/prueba.png";
  }

  const diagnosticsCie10FromHc = () => {
    let tableDiagnostics = [];

    tableDiagnostics.push([
      { text: "CIE-10 ", bold: true, style: "tableheader" },
      { text: "Nombre", bold: true, style: "tableheader" },
      { text: "Tipo", bold: true, style: "tableheader" },
      { text: "Observación", bold: true, style: "tableheader" },
    ]);

    try {
      for (let k = 0; k < data.diagnostico?.addedDiagnostics.length; k++) {
        const element = data.diagnostico?.addedDiagnostics[k];
        tableDiagnostics.push([
          { text: element.codigo, style: "textStyle" },
          { text: element.nombre, style: "textStyle" },
          { text: data.diagnostico?.typesDiag[k], style: "textStyle" },
          { text: data.diagnostico?.observations[k], style: "textStyle" },
        ]);
      }
    } catch (error) {
      console.log(error);
    }

    return tableDiagnostics;
  };

  const labsExams = (exams) => {
    let tableLabsExams = [];

    tableLabsExams.push([
      { text: "CUPS ", style: "textStyle", bold: true },
      { text: "Descripción", style: "textStyle", bold: true },
      { text: "Cant.", style: "textStyle", bold: true },
      { text: "Observación", style: "textStyle", bold: true },
    ]);
    try {
      for (let i = 0; i < exams.length; i++) {
        const element = exams[i];
        tableLabsExams.push([
          { text: element.cupscod, style: "tableTexStyle" },
          { text: element.cupsnom, style: "tableTexStyle" },
          { text: element.cantidad, style: "tableTexStyle" },
          { text: element.observation, style: "tableTexStyle" },
        ]);
      }
    } catch (error) {
      console.log(error);
    }

    return tableLabsExams;
  };

  const personalInformation = () => {
    return {
      // auto-sized columns have their widths based on their content
      margin: [0, 5, 0, 10],
      layout: {
        defaultBorder: false,
      },
      table: {
        widths: ["auto", "*", "auto", "*"],
        body: [
          [
            {
              text: "Datos del Paciente ",
              style: "tableheaderPatient",
              colSpan: 2,
              border: [false, false, false, true],
            },
            "",
            {
              text: "Admisión: " + data.infoAdmission.admision?.id_admision,
              style: "tableheaderPatient",
              border: [false, false, false, true],
            },
            {
              text:
                "Fecha Atención: " +
                moment(data.infoAdmission.admision?.fecha).format("DD-MM-YYYY"),
              style: "tableheaderPatient",
              border: [false, false, false, true],
            },
          ],
          [
            {
              text: "Nombre ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: data.names,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: "Identificación ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: data.typeOfDocument + "-" + data.documentNumber,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "F.Nacimiento ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: moment(data.birthday).format("DD-MM-YYYY"),
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: "Edad ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: calculateAgeParse(data.birthday),
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "Genero ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: data.gender,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: "Tipo de Sangre ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: data.bloodType,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "Dirección ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: data.address,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: "Ciudad ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
            {
              text: data.city,
              style: "textStylePatientInfo",
              border: [false, false, false, false],
            },
          ],
          [
            {
              text: "Estado Civil ",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, true],
            },
            {
              text: data.civilStatus,
              style: "textStylePatientInfo",
              border: [false, false, false, true],
            },
            {
              text: "Tel/Cel:",
              bold: true,
              style: "textStylePatientInfo",
              border: [false, false, false, true],
            },
            {
              text: data.telephone + "/" + data.cellphone,
              style: "textStylePatientInfo",
              border: [false, false, false, true],
            },
          ],
        ],
      },
    };
  };

  const dataLegalRepresent = () => {
    const legalRepresententes = [];

    let hasInformation = false;

    hasInformation = Object.values(
      data.infoAdmission.representante_legal[0]
    ).some((val) => val != "");

    legalRepresententes.push([
      {
        text: "Datos del Representente Legal",
        style: "tableheader",
        border: [false, false, false, true],
        colSpan: 4,
      },
      "",
      "",
      "",
    ]);

    hasInformation === false
      ? legalRepresententes.push([
          {
            text: "No suministra información",
            style: "textRepresentandCompanion",
            colSpan: 4,
          },
          "",
          "",
          "",
        ])
      : null;

    if (hasInformation) {
      for (let k = 0; k < data.infoAdmission.representante_legal.length; k++) {
        const currentLegalReprensent =
          data.infoAdmission.representante_legal[k];

        if (currentLegalReprensent) {
          legalRepresententes.push([
            {
              text: "Nombre:  ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentLegalReprensent.nombre_completo,
              style: "textStyle",
            },
            {
              text: "Identificación: ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentLegalReprensent.num_documento,
              style: "textStyle",
            },
          ]);
          legalRepresententes.push([
            {
              text: "Teléfonos: ",
              bold: true,
              style: "textStyle",
            },
            {
              text:
                currentLegalReprensent.telefono1 +
                " / " +
                currentLegalReprensent.telefono2,
              style: "textStyle",
            },
            {
              text: "Parentesco: ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentLegalReprensent.parentesco,
              style: "textStyle",
            },
          ]);
          legalRepresententes.push([{}, {}, {}, {}]);
        }
      }
    }

    return legalRepresententes;
  };

  const dataCompanion = () => {
    const companions = [];

    let hasInformation =
      data.infoAdmission.acompanante !== null &&
      data.infoAdmission.acompanante.length > 0;

    companions.push([
      {
        text: "Datos del Acompañante",
        style: "tableheader",
        border: [false, false, false, true],
        colSpan: 4,
      },
      "",
      "",
      "",
    ]);

    hasInformation === false
      ? companions.push([
          {
            text: "Sin acompañante",
            style: "textRepresentandCompanion",
            colSpan: 4,
          },
          "",
          "",
          "",
        ])
      : null;

    if (hasInformation) {
      for (let k = 0; k < data.infoAdmission.acompanante.length; k++) {
        const currentCompanion = data.infoAdmission.acompanante[k];

        if (currentCompanion) {
          companions.push([
            {
              text: "Nombre:  ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentCompanion.nombre,
              style: "textStyle",
            },
            {
              text: "Identificación: ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentCompanion.num_documento,
              style: "textStyle",
            },
          ]);
          companions.push([
            {
              text: "Teléfonos: ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentCompanion.tel1 + " / " + currentCompanion.tel2,
              style: "textStyle",
            },
            {
              text: "Parentesco: ",
              bold: true,
              style: "textStyle",
            },
            {
              text: currentCompanion.parentesco,
              style: "textStyle",
            },
          ]);
          companions.push([{}, {}, {}, {}]);
        }
      }
    }

    return companions;
  };

  const dataTiposDisability = () => {
    const tipos = data.infoAdmission.discapacidad.discapacidades.map((d) => {
      const subtipos = d.tipo.map((t) => t.nombre).join(", ");
      return {
        text: [{ text: `${d.nombre}: `, bold: true }, subtipos + "\n"],

        margin: [0, 2, 0, 0],
      };
    });

    return [
      {
        columns: [
          {
            text: "Tipo de discapacidad",
            bold: true,
            margin: [20, 0, 0, 0],
          },
        ],
        margin: [0, 10, 0, 2],
      },
      ...tipos,
    ];
  };

  const ananmnesisInformation = () => {
    if (typeof data.anamnesis !== "undefined") {
      return {
        margin: [0, 5, 0, 15],
        layout: {
          defaultBorder: false,
        },
        table: {
          widths: ["*"],
          headerRows: 1,
          body: [
            [
              {
                text: "Anamnesis ",
                style: "tableheader",
                border: [false, false, false, true],
              },
            ],
            [{ text: "Motivo de Consulta  ", bold: true, style: "textStyle" }],
            [
              {
                text:
                  data.anamnesis.reasonForConsultation !== null
                    ? data.anamnesis.reasonForConsultation
                    : "",
                style: "textStyle",
              },
            ],
            [{ text: "Enfermedad Actual  ", bold: true, style: "textStyle" }],
            [
              {
                text:
                  data.anamnesis.currentIllness !== null
                    ? data.anamnesis.currentIllness
                    : "",
                style: "textStyle",
                border: [false, false, false, true],
              },
            ],
          ],
        },
      };
    } else {
      return null;
    }
  };

  const backgroundInformation = () => {
    if (typeof data.antecedentes !== "undefined") {
      let ailmentsPathologicals = data.antecedentes.pathologicals;
      let hipertension = ailmentsPathologicals.hasOwnProperty("hipertension")
        ? ailmentsPathologicals.hipertension
        : null;
      let metabolicos = ailmentsPathologicals.hasOwnProperty("metabolicos")
        ? ailmentsPathologicals.metabolicos
        : null;
      let cardiacos = ailmentsPathologicals.hasOwnProperty("cardiacos")
        ? ailmentsPathologicals.cardiacos
        : null;
      let infecciosos = ailmentsPathologicals.hasOwnProperty("infecciosos")
        ? ailmentsPathologicals.infecciosos
        : null;
      let vasculares = ailmentsPathologicals.hasOwnProperty("vasculares")
        ? ailmentsPathologicals.vasculares
        : null;
      let alergicos = ailmentsPathologicals.hasOwnProperty("alergicos")
        ? ailmentsPathologicals.alergicos
        : null;
      let cancer = ailmentsPathologicals.hasOwnProperty("cancer")
        ? ailmentsPathologicals.cancer
        : null;
      let transfusiones = ailmentsPathologicals.hasOwnProperty("transfusiones")
        ? ailmentsPathologicals.transfusiones
        : null;
      let autoinmunes = ailmentsPathologicals.hasOwnProperty("autoinmunes")
        ? ailmentsPathologicals.autoinmunes
        : null;
      let traumatico = ailmentsPathologicals.hasOwnProperty("traumatico")
        ? ailmentsPathologicals.traumatico
        : null;
      let diabetes = ailmentsPathologicals.hasOwnProperty("diabetes")
        ? ailmentsPathologicals.diabetes
        : null;
      let hiperlipidemia = ailmentsPathologicals.hasOwnProperty(
        "hiperlipidemia"
      )
        ? ailmentsPathologicals.hiperlipidemia
        : null;
      let enfermedad_coronaria = ailmentsPathologicals.hasOwnProperty(
        "enfermedad_coronaria"
      )
        ? ailmentsPathologicals.enfermedad_coronaria
        : null;
      let enf_vascular_per = ailmentsPathologicals.hasOwnProperty(
        "enf_vascular_per"
      )
        ? ailmentsPathologicals.enf_vascular_per
        : null;
      let hepatitis = ailmentsPathologicals.hasOwnProperty("hepatitis")
        ? ailmentsPathologicals.hepatitis
        : null;

      return {
        margin: [0, 5, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: [150, 50, "*"],
          body: [
            [
              {
                text: "Antecedentes personales ",
                style: "tableheader",
                border: [false, true, false, false],
                colSpan: 3,
              },
              "",
              "",
            ],
            [{ text: "Patologicos: ", bold: true, fontSize: 10 }, "", ""],
            [
              { text: "HIPERTENSIÓN -", style: "textStyle" },
              {
                text: !!hipertension ? hipertension.value : "",
                style: "textStyle",
              },
              {
                text: !!hipertension ? hipertension.comentario : "",
                style: "textStyle",
              },
            ],
            [
              { text: "DIABETES -", style: "textStyle" },
              { text: !!diabetes ? diabetes.value : "", style: "textStyle" },
              {
                text: !!diabetes ? diabetes.comentario : "",
                style: "textStyle",
              },
            ],
            [
              { text: "HIPERLIPIDEMIA -", style: "textStyle" },
              {
                text: !!hiperlipidemia ? hiperlipidemia.value : "",
                style: "textStyle",
              },
              {
                text: !!hiperlipidemia ? hiperlipidemia.comentario : "",
                style: "textStyle",
              },
            ],
            [
              { text: "ENF. CORONARIA", style: "textStyle" },
              {
                text: !!enfermedad_coronaria ? enfermedad_coronaria.value : "",
                style: "textStyle",
              },
              {
                text: !!enfermedad_coronaria
                  ? enfermedad_coronaria.comentario
                  : "",
                style: "textStyle",
              },
            ],
            [
              { text: "ENF. VASCULAR PERIFÉRICA -", style: "textStyle" },
              {
                text: !!enf_vascular_per ? enf_vascular_per.value : "",
                style: "textStyle",
              },
              {
                text: !!enf_vascular_per ? enf_vascular_per.comentario : "",
                style: "textStyle",
              },
            ],
            [
              { text: "HEPATITIS -", style: "textStyle" },
              { text: !!hepatitis ? hepatitis.value : "", style: "textStyle" },
              {
                text: !!hepatitis ? hepatitis.comentario : "",
                style: "textStyle",
              },
            ],
            [
              { text: "CANCER -", style: "textStyle" },
              { text: !!cancer ? cancer.value : "", style: "textStyle" },
              { text: !!cancer ? cancer.comentario : "", style: "textStyle" },
            ],
            [
              { text: "TRANSFUSIONES -", style: "textStyle" },
              {
                text: !!transfusiones ? transfusiones.value : "",
                style: "textStyle",
              },
              {
                text: !!transfusiones ? transfusiones.comentario : "",
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACION -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!ailmentsPathologicals.observacion
                  ? ailmentsPathologicals.observacion
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            ["", "", ""],
            [
              { text: "Quirurgicos: ", bold: true, fontSize: 10 },
              {
                text:
                  data.antecedentes.surgicals.quirurjico.value !== null
                    ? data.antecedentes.surgicals.quirurjico.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.surgicals.quirurjico.comentario !== ""
                    ? data.antecedentes.surgicals.quirurjico.comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACION -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!data.antecedentes.surgicals.observacion
                  ? data.antecedentes.surgicals.observacion
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            [
              { text: "Farmacológicos: ", bold: true, fontSize: 10 },
              {
                text:
                  data.antecedentes.pharmacological.farmacologico.value !== null
                    ? data.antecedentes.pharmacological.farmacologico.value
                    : "",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.pharmacological.farmacologico.hasOwnProperty(
                    "table"
                  ) &&
                  data.antecedentes.pharmacological.farmacologico.table
                    .length != 0
                    ? data.antecedentes.pharmacological.farmacologico.table[0]
                        .principioactivo +
                      " " +
                      data.antecedentes.pharmacological.farmacologico.table[0]
                        .concentracion
                    : "",
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACION -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!data.antecedentes.pharmacological.observacion
                  ? data.antecedentes.pharmacological.observacion
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            [
              { text: "Inmunizaciones: ", bold: true, fontSize: 10 },
              {
                text:
                  data.antecedentes.inmunizations.inmunizaciones.value !== null
                    ? data.antecedentes.inmunizations.inmunizaciones.value
                    : "",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.inmunizations.inmunizaciones.hasOwnProperty(
                    "table"
                  ) &&
                  data.antecedentes.inmunizations.inmunizaciones.table.length !=
                    0
                    ? data.antecedentes.inmunizations.inmunizaciones.table[0]
                        .vacuna +
                      " " +
                      data.antecedentes.inmunizations.inmunizaciones.table[0]
                        .fecha
                    : "",
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACION -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!data.antecedentes.inmunizations.observacion
                  ? data.antecedentes.inmunizations.observacion
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            ["", "", ""],
            [{ text: "Familiares: ", bold: true, fontSize: 10 }, "", ""],
            [
              { text: "CANCER -", style: "textStyle" },
              {
                text:
                  data.antecedentes.family.cancer.value !== null
                    ? data.antecedentes.family.cancer.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.family.cancer.comentario !== ""
                    ? data.antecedentes.family.cancer.comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "DIABETES -", style: "textStyle" },
              {
                text:
                  data.antecedentes.family.diabetes.value !== null
                    ? data.antecedentes.family.diabetes.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.family.diabetes.comentario !== ""
                    ? data.antecedentes.family.diabetes.comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "ENF. CORONARIA -", style: "textStyle" },
              {
                text:
                  data.antecedentes.family.enfermedad_coronaria.value !== null
                    ? data.antecedentes.family.enfermedad_coronaria.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.family.enfermedad_coronaria.comentario !==
                  ""
                    ? data.antecedentes.family.enfermedad_coronaria.comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "HIPERTENSION -", style: "textStyle" },
              {
                text:
                  data.antecedentes.family.hipertension.value !== null
                    ? data.antecedentes.family.hipertension.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.family.hipertension.comentario !== ""
                    ? data.antecedentes.family.hipertension.comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              { text: "MUERTE SUBITA -", style: "textStyle" },
              {
                text:
                  data.antecedentes.family.muerte_subita.value !== null
                    ? data.antecedentes.family.muerte_subita.value
                    : "No Refiere",
                style: "textStyle",
              },
              {
                text:
                  data.antecedentes.family.muerte_subita.comentario !== ""
                    ? data.antecedentes.family.muerte_subita.comentario
                    : "",
                style: "textStyle",
              },
            ],
            [
              {
                text: "OBSERVACION -",
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: !!data.antecedentes.family.observacion
                  ? data.antecedentes.family.observacion
                  : "",
                style: "textStyle",
                colSpan: 2,
                border: [false, false, false, true],
              },
              "",
            ],
            ["", "", ""],
          ],
        },
      };
    } else {
      return null;
    }
  };

  const backgroundInformationHabits = () => {
    if (typeof data.antecedentes !== "undefined") {
      let subtances = [];
      let sustancias = [
        "cocaina",
        "bazuco",
        "extasis",
        "heroina",
        "lcd",
        "hongos",
        "marihuana",
        "ghb",
      ];
      if (data.antecedentes.habits.substaces.includes("Cocaina")) {
        subtances.push("Cocaina");
      } else if (data.antecedentes.habits.substaces.includes("Bazuco")) {
        subtances.push("Bazuco");
      } else if (data.antecedentes.habits.substaces.includes("Extasis")) {
        subtances.push("Extasis");
      } else if (data.antecedentes.habits.substaces.includes("Heroina")) {
        subtances.push("Heroina");
      } else if (data.antecedentes.habits.substaces.includes("LSD")) {
        subtances.push("LCD");
      } else if (data.antecedentes.habits.substaces.includes("Hongos")) {
        subtances.push("Hongos");
      } else if (data.antecedentes.habits.substaces.includes("Marihuana")) {
        subtances.push("Marihuana");
      } else if (data.antecedentes.habits.substaces.includes("GHB")) {
        subtances.push("GHB");
      }
      let riesgoFumador = "";
      let ipa = "";
      if (data.antecedentes.habits.packegesPerYear < 20) {
        ipa = data.antecedentes.habits.packegesPerYear.toString();
        riesgoFumador = ipa + " IPA - Riesgo leve";
      } else if (
        data.antecedentes.habits.packegesPerYear > 19 &&
        data.antecedentes.habits.packegesPerYear < 40
      ) {
        ipa = data.antecedentes.habits.packegesPerYear.toString();
        riesgoFumador = ipa + " IPA - Riesgo moderado";
      } else {
        ipa = data.antecedentes.habits.packegesPerYear.toString();
        riesgoFumador = ipa + " IPA Riesgo alto";
      }
      return {
        unbreakable: true,
        margin: [0, 10, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "*"],
          body: [
            [
              {
                text: "Antecedentes Habitos",
                style: "tableheader",
                colSpan: 4,
                border: [false, false, false, true],
              },
              "",
              "",
              "",
            ],
            [
              { text: "Fumador: ", style: "textStyle", bold: true },
              {
                text:
                  data.antecedentes.habits.smoke === ""
                    ? "No"
                    : data.antecedentes.habits.smoke,
                style: "textStyle",
              },
              {
                text: "Indice de cigarillos por año: ",
                style: "textStyle",
                bold: true,
              },
              {
                text:
                  data.antecedentes.habits.packegesPerYear === ""
                    ? ""
                    : riesgoFumador,
                style: "textStyle",
              },
            ],
            [
              {
                text: "Exposición Humo de Leña : ",
                style: "textStyle",
                bold: true,
              },
              {
                text:
                  data.antecedentes.habits.firewood === ""
                    ? "No"
                    : data.antecedentes.habits.firewood,
                style: "textStyle",
              },
              { text: "Años de Exposición: ", style: "textStyle", bold: true },
              {
                text:
                  data.antecedentes.habits.years === ""
                    ? "Ninguno"
                    : data.antecedentes.habits.years,
                style: "textStyle",
              },
            ],
            [
              {
                text: "Sustancias Psicoactivas: ",
                style: "textStyle",
                bold: true,
              },
              { text: data.antecedentes.habits.comsuption, style: "textStyle" },
              { text: "Sustancias: ", style: "textStyle", bold: true },
              {
                text:
                  data.antecedentes.habits.comsuption === "No"
                    ? data.antecedentes.habits.comsuption
                    : subtances.toString(),
                style: "textStyle",
              },
            ],
            [
              { text: "Consumo de Alcohol: ", style: "textStyle", bold: true },
              { text: data.antecedentes.habits.alcohol, style: "textStyle" },
              {
                text: "Consumo de Alcohol en el ultimo año: ",
                style: "textStyle",
                bold: true,
              },
              {
                text:
                  data.antecedentes.habits.alcohol === "Si"
                    ? " Frec." + data.antecedentes.habits.frecuencyAlcohol
                    : "No",
                style: "textStyle",
              },
            ],
            [
              {
                text: "Actividad Fisica: ",
                style: "textStyle",
                bold: true,
                border: [false, false, false, true],
              },
              {
                text: data.antecedentes.habits.physicalActivity,
                style: "textStyle",
                border: [false, false, false, true],
              },
              {
                text: "Actividades/Frecuencia: ",
                style: "textStyle",
                bold: true,
                border: [false, false, false, true],
              },
              {
                text:
                  data.antecedentes.habits.activities.length !== 0
                    ? data.antecedentes.habits.activities.toString()
                    : "",
                style: "textStyle",
                border: [false, false, false, true],
              },
            ],
          ],
        },
      };
    } else {
      return null;
    }
  };

  const systemInformation = () => {
    try {
      if (data.sistemas != null && data.sistemas != undefined) {
        return {
          unbreakable: true,
          margin: [0, 10, 0, 10],
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*"],
            headerRows: 1,
            body: [
              [
                {
                  text: "Revisión por sistema",
                  style: "tableheader",
                  colSpan: 2,
                  border: [false, false, false, true],
                },
                "",
              ],
              [
                { text: "Síntomas Generales: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[0].commentary,
                  style: "textStyle",
                },
              ],
              [
                { text: "Respiratorios: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[1].commentary,
                  style: "textStyle",
                },
              ],
              [
                { text: "Cardiovascular: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[2].commentary,
                  style: "textStyle",
                },
              ],
              [
                { text: "Gastrointestinal: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[3].commentary,
                  style: "textStyle",
                },
              ],
              [
                { text: "Genitourinario: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[4].commentary,
                  style: "textStyle",
                },
              ],
              [
                { text: "Osteomuscular: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[5].commentary,
                  style: "textStyle",
                },
              ],
              [
                { text: "Dermatologico: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[6].commentary,
                  style: "textStyle",
                },
              ],
              [
                { text: "Endocrino: ", bold: true, fontSize: 10 },
                {
                  text: data.sistemas?.ailments[7].commentary,
                  style: "textStyle",
                },
              ],
              [
                {
                  text: "Neurologico: ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                },
                {
                  text: data.sistemas?.ailments[8].commentary,
                  style: "textStyle",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        };
      }
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const physicalInformations = () => {
    try {
      if (data.fisico != null && data.fisico != undefined) {
        return {
          unbreakable: true,
          margin: [0, 5, 0, 10],
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*", "auto", "*"],
            headerRows: 1,
            body: [
              [
                {
                  text: "Examen Fisico ",
                  style: "tableheader",
                  border: [false, false, false, true],
                  colSpan: 4,
                },
                "",
                "",
                "",
              ],
              [
                { text: "Genero ", style: "textStyle", bold: true },
                { text: data.gender, style: "textStyle" },
                { text: "Frecuencia Cardiaca", style: "textStyle", bold: true },
                {
                  text: data.fisico.heartRate + " (lpm)",
                  style: "textStyle",
                },
              ],
              [
                { text: "Peso ", style: "textStyle", bold: true },
                {
                  text: !!data.fisico.weight
                    ? data.fisico.weight + " (kg)"
                    : "",
                  style: "textStyle",
                },
                {
                  text: "Frecuencia Respiratoria",
                  style: "textStyle",
                  bold: true,
                },
                {
                  text: data.fisico.breathingFrequency + " (resp/min)",
                  style: "textStyle",
                },
              ],
              [
                { text: "Talla ", style: "textStyle", bold: true },
                {
                  text: !!data.fisico.size ? data.fisico.size + "(cm)" : "",
                  style: "textStyle",
                },
                { text: "Presiona Arterial", style: "textStyle", bold: true },
                {
                  text:
                    data.fisico.bloodPressureMM +
                    "/" +
                    data.fisico.bloodPressureHg +
                    " (mmHg)",
                  style: "textStyle",
                },
              ],
              [
                {
                  text: "Superficie Corporal ",
                  style: "textStyle",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: !!parseFloat(data.fisico.bodySurface)
                    ? data.fisico.bodySurface
                    : "" + " (mc)",
                  style: "textStyle",
                  border: [false, false, false, true],
                },
                {
                  text: "Índice de Masa Corporal",
                  style: "textStyle",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: !!data.fisico.BMI ? data.fisico.BMI : "",
                  style: "textStyle",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const physicalInformationBody = () => {
    try {
      if (data.fisico != null && data.fisico != undefined) {
        return {
          margin: [0, 20, 0, 10],
          pageOrientation: "portrait",
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Aspecto General: ",
                  bold: true,
                  fontSize: 10,
                  border: [false, true, false, false],
                },
                {
                  text: data.fisico.generalFeatures,
                  style: "textStyle",
                  border: [false, true, false, false],
                },
              ],
              [
                { text: "Cabeza y Cara: ", bold: true, fontSize: 10 },
                { text: data.fisico.headAndFace, style: "textStyle" },
              ],
              [
                { text: "Otorino: ", bold: true, fontSize: 10 },
                { text: data.fisico.otorhino, style: "textStyle" },
              ],
              [
                { text: "Ojos: ", bold: true, fontSize: 10 },
                { text: data.fisico.eyes, style: "textStyle" },
              ],
              [
                { text: "Cuello: ", bold: true, fontSize: 10 },
                { text: data.fisico.neck, style: "textStyle" },
              ],
              [
                { text: "Torax: ", bold: true, fontSize: 10 },
                { text: data.fisico.chest, style: "textStyle" },
              ],
              [
                { text: "Cardiovascular ", bold: true, fontSize: 10 },
                { text: data.fisico.cardioVascular, style: "textStyle" },
              ],
              [
                { text: "Pulmonar ", bold: true, fontSize: 10 },
                { text: data.fisico.pulmonary, style: "textStyle" },
              ],
              [
                { text: "Abdomen ", bold: true, fontSize: 10 },
                { text: data.fisico.abdomen, style: "textStyle" },
              ],
              [
                { text: "Extremidades ", bold: true, fontSize: 10 },
                { text: data.fisico.limbs, style: "textStyle" },
              ],
              [
                { text: "Neurologico ", bold: true, fontSize: 10 },
                { text: data.fisico.neurological, style: "textStyle" },
              ],
              [
                { text: "Genitourinatio ", bold: true, fontSize: 10 },
                { text: data.fisico.genitourinary, style: "textStyle" },
              ],
              [
                {
                  text: "Piel y Fanareas ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                },
                {
                  text: data.fisico.skin_appendages,
                  style: "textStyle",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  let bodyDiagnostic = [];

  if (typeof data.diagnostico !== "undefined") {
    bodyDiagnostic.push(
      [{ text: "Diagnóstico", style: "tableheader", colSpan: 2 }, "", "", ""],
      [
        { text: "Codigo CIE-10 ", style: "textStyle", bold: true },
        { text: "Nombre", style: "textStyle", bold: true },
        { text: "Tipo", style: "textStyle", bold: true },
        { text: "Observación", style: "textStyle", bold: true },
      ]
    );

    for (let i = 0; i < data.diagnostico.addedDiagnostics.length; i++) {
      bodyDiagnostic.push([
        {
          text: data.diagnostico.addedDiagnostics[i].codigo,
          style: "tableTexStyle",
        },
        {
          text: data.diagnostico.addedDiagnostics[i].nombre,
          style: "tableTexStyle",
        },
        {
          text: data.diagnostico.addedDiagnostics[i].hasOwnProperty("tipo")
            ? data.diagnostico.addedDiagnostics[i].tipo
            : "",
          style: "tableTexStyle",
        },
        {
          text: data.diagnostico.addedDiagnostics[i].hasOwnProperty(
            "observacion"
          )
            ? data.diagnostico.addedDiagnostics[i].observacion
            : "",
          style: "tableTexStyle",
        },
      ]);
    }
  }

  const diagnosticInformation = (opt) => {
    try {
      if (data.diagnostico !== undefined) {
        switch (opt) {
          case 1:
            return {
              unbreakable: true,
              margin: [0, 5, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: ["*", "auto", "*", "*"],
                headerRows: 1,
                body: bodyDiagnostic,
              },
            };
            break;
          case 2:
            if (data.diagnostico.hasOwnProperty("generalObservation")) {
              if (!!data.diagnostico.generalObservation) {
                return {
                  text: "Observación Diagnóstico",
                  style: "tableheader",
                  layout: "lightHorizontalLines",
                };
              } else {
                return null;
              }
            } else {
              return null;
            }
            break;
          case 3:
            if (data.diagnostico.hasOwnProperty("generalObservation")) {
              if (!!data.diagnostico.generalObservation) {
                return {
                  text: data.diagnostico.generalObservation,
                  style: "textStyle",
                };
              } else {
                return null;
              }
            } else {
              return null;
            }
            break;

          default:
            break;
        }
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  const medicalPlanInformation = () => {
    try {
      if (data.plan != undefined) {
        return {
          margin: [0, 5, 0, 10],
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*"],
            headerRows: 1,
            body: [
              [
                {
                  text: "Analisis y Plan Medico ",
                  style: "tableheader",
                  colSpan: 2,
                  border: [false, false, false, true],
                },
                "",
              ],
              [
                { text: "Analisis: ", bold: true, style: "textStyle" },
                { text: data.plan.analysis, style: "textStyle" },
              ],
              [
                { text: "Plan Medico: ", bold: true, style: "textStyle" },
                { text: data.plan.plan, style: "textStyle" },
              ],
              [
                {
                  text: "Recomendaciones: ",
                  bold: true,
                  style: "textStyle",
                  border: [false, false, false, true],
                },
                {
                  text: data.plan.recommendations,
                  style: "textStyle",
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  let htmlSpeechTerapy = null;
  if (!!data.speechTerapy) {
    htmlSpeechTerapy = htmlToPdfmake(data.speechTerapy);
  }

  const proceduresInformations = (opt) => {
    switch (opt) {
      case 1:
        if (htmlSpeechTerapy != undefined && htmlSpeechTerapy != null) {
          return {
            text: "Procedimientos",
            style: "tableheader",
            layout: "lightHorizontalLines",
          };
        } else {
          return null;
        }
        break;
      case 2:
        if (htmlSpeechTerapy != undefined && htmlSpeechTerapy != null) {
          return {
            margin: [0, 5, 0, 10],
            layout: "headerLineOnly",
            style: "tableText",
            table: {
              widths: ["*"],
              headerRows: 1,
              body: [
                [{ text: "Audiometria ", style: "tableheader" }],
                [htmlSpeechTerapy],
              ],
            },
          };
        } else {
          return null;
        }
        break;
      case 3:
        if (htmlSpeechTerapy != undefined && htmlSpeechTerapy != null) {
          return htmlSpeechTerapy;
        } else {
          return null;
        }
        break;
    }
  };

  let bodyExamsPr = [];

  if (typeof data.ordenes !== "undefined") {
    bodyExamsPr[0] = [
      { text: "CUPS ", style: "textStyle", bold: true },
      { text: "Descripción", style: "textStyle", bold: true },
      { text: "Cant.", style: "textStyle", bold: true },
      { text: "Observaciones", style: "textStyle", bold: true },
    ];

    for (let i = 0; i < data.ordenes.length; i++) {
      bodyExamsPr[i + 1] = [
        {
          text: data.ordenes[i].cupscod,
          style: "tableTexStyle",
        },
        {
          text: data.ordenes[i].cupsnom,
          style: "tableTexStyle",
        },
        {
          text: data.hasOwnProperty("amounts") ? data.amounts[i] : "",
          style: "tableTexStyle",
        },
        {
          text: data.hasOwnProperty("observations") ? data.observations[i] : "",
          style: "tableTexStyle",
        },
      ];
    }
  }

  let tableBodyMedicine = [];

  console.log("data.ordenes_formula", data.ordenes_formula);

  if (!!data.ordenes_formula) {
    if (!!data.ordenes_formula.length) {
      tableBodyMedicine.push(
        [
          { text: "Medicamentos", style: "tableheader", colSpan: 2 },
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ],
        [
          { text: "Principio", bold: true, fontSize: 10 },
          { text: "Con.", bold: true, fontSize: 10 },
          { text: "Forma Farm.", bold: true, fontSize: 10 },
          { text: "Via", bold: true, fontSize: 10 },
          { text: "Dosis", bold: true, fontSize: 10 },
          { text: "Frecuencia", bold: true, fontSize: 10 },
          { text: "Duración", bold: true, fontSize: 10 },
          { text: "Und.", bold: true, fontSize: 10 },
        ]
      );

      try {
        for (let k = 0; k < data.ordenes_formula.length; k++) {
          tableBodyMedicine.push([
            {
              text: data.ordenes_formula[k].activePrinciple,
              style: "tableTexStyle",
            },
            {
              text: data.ordenes_formula[k].concentration,
              style: "tableTexStyle",
            },
            {
              text: data.ordenes_formula[k].pharmaceuticalForm,
              style: "tableTexStyle",
            },
            {
              text: data.ordenes_formula[k].route,
              style: "tableTexStyle",
            },
            {
              text: data.ordenes_formula[k].dose,
              style: "tableTexStyle",
            },
            {
              text:
                data.ordenes_formula[k].frequency === "Otros"
                  ? data.ordenes_formula[k].otherFrequency ??
                    data.ordenes_formula[k].frequency
                  : data.ordenes_formula[k].frequency,
              style: "tableTexStyle",
            },
            {
              text: data.ordenes_formula[k].duration,
              style: "tableTexStyle",
            },
            {
              text: data.ordenes_formula[k].units,
              style: "tableTexStyle",
            },
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  const medicalOrdersInformation = (opt) => {
    try {
      switch (opt) {
        case 1:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              text: "Formulación Examenes/Consultas",
              style: "tableheader",
            };
          } else {
            return null;
          }
          break;
        case 2:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              margin: [0, 10, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: ["*", "auto", "*", "*"],
                headerRows: 1,
                body: bodyExamsPr,
              },
            };
          } else {
            return null;
          }
          break;
        case 3:
          if (data.ordenes != null && data.ordenes != undefined) {
            if (
              data.observationAndProcedure != null &&
              data.observationAndProcedure != ""
            ) {
              return {
                text: "Observaciones de Examenes/Consultas",
                style: "tableheader",
                layout: "lightHorizontalLines",
              };
            }
          } else {
            return null;
          }
          break;
        case 4:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              text: data.observationAndProcedure,
              style: "textStyle",
            };
          } else {
            return null;
          }
          break;
        case 5:
          if (
            data.ordenes_formula != null &&
            data.ordenes_formula != undefined &&
            data.ordenes_formula.length
          ) {
            return {
              unbreakable: true,
              margin: [0, 5, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: [80, "*", "*", "*", "*", "*", "*", "*"],
                headerRows: 1,
                body: tableBodyMedicine,
              },
            };
          } else {
            return null;
          }
          break;
        case 6:
          if (data.ordenes != null && data.ordenes != undefined) {
            if (
              data.medicalObservation != null &&
              data.medicalObservation != ""
            ) {
              return {
                text: "Observaciones de Medicamentos",
                style: "tableheader",
                layout: "lightHorizontalLines",
              };
            }
          } else {
            return null;
          }
          break;
        case 7:
          if (data.ordenes != null && data.ordenes != undefined) {
            return {
              text: data.medicalObservation,
              style: "textStyle",
            };
          } else {
            return null;
          }
          break;
      }
    } catch (err) {
      return null;
    }
  };

  let tableBodyOtherProcedures = [["", ""]];
  if (data.otherProcedures !== undefined && data.otherProcedures !== null) {
    let resultsPocedures = [];
    if (
      data.otherProcedures.hasOwnProperty("ECO") ||
      data.otherProcedures.hasOwnProperty("Stress") ||
      data.otherProcedures.hasOwnProperty("Test") ||
      data.otherProcedures.hasOwnProperty("EKG") ||
      data.otherProcedures.hasOwnProperty("Holter") ||
      data.otherProcedures.hasOwnProperty("Map")
    ) {
      console.log(
        "ECO",
        await validateFromHCProcessECO(data.otherProcedures.ECO),
        "estres",
        await validateFromHCProcessStress(data.otherProcedures.Stress),
        "prueba",
        await validateFromHCProcessTest(data.otherProcedures.Test),
        "ekg",
        await validateFromHCProcessEKG(data.otherProcedures.EKG),
        "holter",
        await validateFromHCProcessHolter(data.otherProcedures.Holter),
        "mapa",
        await validateFromHCProcessMap(data.otherProcedures.Map)
      );
      let resultOtherProcedureEco = (await validateFromHCProcessECO(
        data.otherProcedures.ECO
      ))
        ? data.otherProcedures.ECO.conclusions
        : null;
      let resultOtherProcedureEstres = (await validateFromHCProcessStress(
        data.otherProcedures.Stress
      ))
        ? data.otherProcedures.Stress.conclusions
        : null;
      let resultOtherProcedurePrueba = (await validateFromHCProcessTest(
        data.otherProcedures.Test
      ))
        ? data.otherProcedures.Test.conclusions
        : null;
      let resultOtherProcedureEkg = (await validateFromHCProcessEKG(
        data.otherProcedures.EKG
      ))
        ? data.otherProcedures.EKG.conclusions !== undefined &&
          data.otherProcedures.EKG.conclusions !== null
          ? data.otherProcedures.EKG.conclusions
          : data.otherProcedures.EKG.conclusion !== undefined &&
            data.otherProcedures.EKG.conclusion !== null
          ? data.otherProcedures.EKG.conclusion
          : null
        : null;
      let resultOtherProcedureHolter = (await validateFromHCProcessHolter(
        data.otherProcedures.Holter
      ))
        ? data.otherProcedures.Holter.conclusion
        : null;
      let resultOtherProcedureMapa = (await validateFromHCProcessMap(
        data.otherProcedures.Map
      ))
        ? data.otherProcedures.Map.conclusion
        : null;

      if (resultOtherProcedureEco !== null) {
        let nameServ = data?.infoAdmission.servicios.servicios.filter(
          (serv) => serv.formato === "1"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureEco,
          });
        }
      }
      if (resultOtherProcedureEstres !== null) {
        let nameServ = data?.infoAdmission.servicios.servicios.filter(
          (serv) => serv.formato === "3"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureEstres,
          });
        }
      }
      if (resultOtherProcedurePrueba !== null) {
        let nameServ = data?.infoAdmission.servicios.servicios.filter(
          (serv) => serv.formato === "4"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedurePrueba,
          });
        }
      }
      if (resultOtherProcedureEkg !== null) {
        let nameServ = data?.infoAdmission.servicios.servicios.filter(
          (serv) => serv.formato === "2"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureEkg,
          });
        }
      }
      if (resultOtherProcedureHolter !== null) {
        let nameServ = data?.infoAdmission.servicios.servicios.filter(
          (serv) => serv.formato === "6"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureHolter,
          });
        }
      }
      if (resultOtherProcedureMapa !== null) {
        let nameServ = data?.infoAdmission.servicios.servicios.filter(
          (serv) => serv.formato === "7"
        );
        if (JSON.stringify(nameServ) !== "[]") {
          resultsPocedures.push({
            ["service_name"]: nameServ[0].nombre,
            ["code_cups"]: nameServ[0].codigo,
            ["result_procedure"]: resultOtherProcedureMapa,
          });
        }
      }

      console.log("MASDE1PROCEDIMIENTO", resultsPocedures);
      console.log(
        "TIPO",
        typeof resultsPocedures,
        "CONT",
        resultsPocedures,
        "json",
        JSON.stringify(resultsPocedures)
      );
    }
    console.log("WDO", resultsPocedures);
    if (!!resultsPocedures) {
      if (!!resultsPocedures.length) {
        try {
          for (let k = 0; k < resultsPocedures.length; k++) {
            const search = "\n";
            const replaceWith = "<br />";
            const result = resultsPocedures[k].result_procedure
              .split(search)
              .join(replaceWith);
            let htmlProceduresConclusion = htmlToPdfmake(result, {
              defaultStyles: {
                table: {
                  width: ["auto", "*"],
                },
              },
              tableAutoSize: true,
            });
            //let htmlProceduresConclusion = htmlToPdfmake(result);
            console.log("htmlProceduresConclusion", htmlProceduresConclusion);
            tableBodyOtherProcedures.push(
              [personalInformation(), ""],
              [
                {
                  text:
                    resultsPocedures[k].code_cups +
                    " " +
                    resultsPocedures[k].service_name,
                  bold: true,
                  colSpan: 2,
                  style: "textStyle",
                },
                "",
              ],
              [htmlProceduresConclusion, ""],
              [
                {
                  margin: [0, 50, 0, 0],
                  image: await getImage(urlFirma),
                  fit: [80, 80],
                },
                "",
              ],
              [
                {
                  pageBreak: k + 1 === resultsPocedures.length ? "" : "after",
                  text:
                    "Dr.(a) " +
                    data.professional.nombres +
                    " " +
                    data.professional.apellido1 +
                    " " +
                    data.professional.apellido2 +
                    "\n" +
                    esp +
                    "\n REG-" +
                    data.professional.reg_medico,
                  style: "medicStyle",
                },
                "",
              ]
            );
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  const otherProceduresResults = () => {
    try {
      if (data.otherProcedures !== null && data.otherProcedures !== undefined) {
        return {
          margin: [0, 10, 0, 5],
          layout: "noBorders",
          style: "tableText",
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: tableBodyOtherProcedures,
          },
        };
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const IncapacityInfo = () => {
    try {
      if (
        data.infoIncapacityCurrentAdmision !== null &&
        data.infoIncapacityCurrentAdmision !== undefined
      ) {
        return {
          margin: [0, 10, 0, 5],
          layout: {
            defaultBorder: false,
          },
          style: "tableText",
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Incapacidad ",
                  style: "tableheader",
                  bold: true,
                  alignment: "rigth",
                  border: [false, false, false, true],
                  colSpan: 4,
                },
                "",
                "",
                "",
              ],
              [
                {
                  text: "Días de incapacidad: ",
                  style: "textStyle",
                  bold: true,
                  alignment: "rigth",
                },
                {
                  text: data.infoIncapacityCurrentAdmision[0]?.dias_incapacidad,
                  style: "textStyle",
                  alignment: "rigth",
                },
                {
                  text:
                    "Fecha de inicio: " +
                    moment(
                      data.infoIncapacityCurrentAdmision[0]?.fecha_incial
                    ).format("DD-MM-YYYY"),
                  style: "textStyle",
                  bold: true,
                  alignment: "left",
                },
                {
                  text:
                    "Fecha en la que termina: " +
                    moment(
                      data.infoIncapacityCurrentAdmision[0]?.fecha_final
                    ).format("DD-MM-YYYY"),
                  style: "textStyle",
                  bold: true,
                  alignment: "left",
                },
              ],
              [
                {
                  text: "Observaciones: ",
                  style: "textStyle",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: data.infoIncapacityCurrentAdmision[0]?.observaciones,
                  style: "textStyle",
                  colSpan: 3,
                  border: [false, false, false, true],
                },
                "",
                "",
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.nombre +
              "\n Nit: " +
              data.profile.nit +
              "\n" +
              data.profile.direccion.direccion +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2 +
              " \n Fecha de Atención: " +
              data.day,
            style: "head",
          },
        ],
      ],
    },
  };

  body_formula[0] = [
    { text: "No.", style: "textStyle", bold: true },
    { text: "Nombre el Medicamento", style: "textStyle", bold: true },
    { text: "Concentración", style: "textStyle", bold: true },
    { text: "Forma Farmacéutica", style: "textStyle", bold: true },
    { text: "Via", style: "textStyle", bold: true },
    { text: "Dosis", style: "textStyle", bold: true },
    { text: "Frecuencia", style: "textStyle", bold: true },
    { text: "Duración / Tratamiento / Días", style: "textStyle", bold: true },
    { text: "Cant.", style: "textStyle", bold: true },
  ];
  if (
    data.ordenes_formula !== null &&
    data.ordenes_formula !== undefined &&
    data.ordenes_formula.length > 0
  ) {
    for (let i = 0; i < data.ordenes_formula.length; i++) {
      body_formula[i + 1] = [
        { text: i + 1, style: "tableTexStyle" },
        {
          text: data.ordenes_formula[i].activePrinciple,
          style: "tableTexStyle",
        },
        { text: data.ordenes_formula[i].concentration, style: "tableTexStyle" },
        {
          text: data.ordenes_formula[i].pharmaceuticalForm,
          style: "tableTexStyle",
        },
        { text: data.ordenes_formula[i].route, style: "tableTexStyle" },
        { text: data.ordenes_formula[i].dose, style: "tableTexStyle" },
        {
          text:
            data.ordenes_formula[i].frequency === "Otros"
              ? data.ordenes_formula[i].otherFrequency ??
                data.ordenes_formula[i].frequency
              : data.ordenes_formula[i].frequency,
          style: "tableTexStyle",
        },
        { text: data.ordenes_formula[i].duration, style: "tableTexStyle" },
        { text: data.ordenes_formula[i].units, style: "tableTexStyle" },
      ];
    }
  }

  if (
    data.ordenes_formula !== null &&
    data.ordenes_formula !== undefined &&
    data.ordenes_formula.length > 0 &&
    !data.showClinicEvent
  ) {
    docContent.push(
      {
        text: "FORMULA MÉDICA",
        style: "tableheader",
        alignment: "center",
        margin: [0, 10, 0, 0],
      },
      {
        text:
          "Lugar y Fecha de la Prescripción: " +
          getCity[0].ciunom +
          ", " +
          format_today,
        style: "textStyle",
        margin: [0, 10, 0, 0],
      },
      {
        text:
          typeof data.third?.nombre === "undefined"
            ? ""
            : "ENTIDAD: " + data.third?.nombre,
        style: "textStyle",
        bold: true,
      },
      {
        // auto-sized columns have their widths based on their content
        margin: [0, 20, 0, 10],
        layout: "headerLineOnly",
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "*"],
          body: [
            [
              { text: "Datos del Paciente ", style: "tableheader", colSpan: 2 },
              "",
              "",
              "",
            ],
            [
              { text: "Nombre ", bold: true, style: "textStyle" },
              { text: data.names, style: "textStyle" },
              {
                text: "Documento de Identificación: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: data.typeOfDocument + " " + data.documentNumber,
                style: "textStyle",
              },
            ],
            [
              { text: "Edad ", bold: true, style: "textStyle" },
              { text: calculateAgeParse(data.birthday), style: "textStyle" },
              { text: "Genero ", bold: true, style: "textStyle" },
              { text: data.gender, style: "textStyle" },
            ],
            [
              { text: "Historia Clínica ", bold: true, style: "textStyle" },
              {
                text:
                  data.id_historia !== undefined && data.id_historia !== null
                    ? data.id_historia
                    : "",
                style: "textStyle",
              },
              { text: "Regimen: ", bold: true, style: "textStyle" },
              {
                text:
                  data.regime !== undefined && data.regime !== null
                    ? data.regime
                    : "",
                style: "textStyle",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 10, 0, 10],
        layout: "headerLineOnly",
        table: {
          widths: [
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "auto",
            "*",
            "auto",
          ],
          headerRows: 1,
          body: body_formula,
        },
      },
      data.medicalObservation !== undefined &&
        data.medicalObservation !== null &&
        data.medicalObservation !== ""
        ? {
            margin: [0, 10, 0, 10],
            layout: "headerLineOnly",
            table: {
              widths: ["auto", "*"],
              headerRows: 1,
              body: [
                [
                  { text: "Observaciones: ", bold: true, style: "textStyle" },
                  { text: data.medicalObservation, style: "textStyle" },
                ],
              ],
            },
          }
        : null,
      {
        margin: [0, 50, 0, 0],
        image: await getImage(urlFirma),
        fit: [80, 80],
      },
      data.professional !== undefined && data.professional !== null
        ? {
            pageBreak: "after",
            text:
              "Dr.(a) " +
              nombres +
              " " +
              apellido1 +
              " " +
              apellido2 +
              "\n" +
              esp +
              "\n REG-" +
              reg_medico,
            style: "medicStyle",
          }
        : null
    );
  }

  let examsPlusObservations = data.ordenes.map((exam, index) => {
    let cExam = exam;
    console.log(
      "WHTTT",
      exam.cupscod.substring(0, 2),
      typeof exam.cupscod.substring(0, 2),
      exam.cupscod.slice(0, 2),
      typeof exam.cupscod.slice(0, 2)
    );
    cExam.observation = data.observations[index];
    cExam.cantidad = data.amounts[index];
    return cExam;
  });
  let laboratoryExams = examsPlusObservations.filter(
    (exam) => exam.tipo === 1 || exam.cupscod.substring(0, 2) === "90"
  );
  let exams = data.ordenes.filter(
    (exam) =>
      (!exam.hasOwnProperty("tipo") || exam.tipo !== 1) &&
      exam.cupscod.substring(0, 2) !== "90"
  );

  if (!!laboratoryExams && !data.showClinicEvent) {
    if (!!laboratoryExams.length) {
      docContent.push(
        {
          text: "SOLICITUD DE PROCEDIMIENTOS",
          style: "tableheader",
          alignment: "center",
          margin: [0, 10, 0, 0],
        },
        {
          text:
            "Lugar y Fecha de la Prescripción: " +
            getCity[0].ciunom +
            ", " +
            format_today,
          style: "textStyle",
          margin: [0, 10, 0, 0],
        },
        {
          text:
            typeof data.third?.nombre === "undefined"
              ? ""
              : "ENTIDAD: " + data.third?.nombre,
          style: "textStyle",
          bold: true,
        },
        {
          // auto-sized columns have their widths based on their content
          margin: [0, 20, 0, 10],
          layout: "headerLineOnly",
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Datos del Paciente ",
                  style: "tableheader",
                  colSpan: 2,
                },
                "",
                "",
                "",
              ],
              [
                { text: "Nombre ", bold: true, style: "textStyle" },
                { text: data.names, style: "textStyle" },
                {
                  text: "Documento de Identificación: ",
                  bold: true,
                  style: "textStyle",
                },
                {
                  text: data.typeOfDocument + " " + data.documentNumber,
                  style: "textStyle",
                },
              ],
              [
                { text: "Edad ", bold: true, style: "textStyle" },
                { text: calculateAgeParse(data.birthday), style: "textStyle" },
                { text: "Genero ", bold: true, style: "textStyle" },
                { text: data.gender, style: "textStyle" },
              ],
              [
                { text: "Historia Clínica ", bold: true, style: "textStyle" },
                {
                  text:
                    data.id_historia !== undefined && data.id_historia !== null
                      ? data.id_historia
                      : "",
                  style: "textStyle",
                },
                { text: "Regimen: ", bold: true, style: "textStyle" },
                {
                  text:
                    data.regime !== undefined && data.regime !== null
                      ? data.regime
                      : "",
                  style: "textStyle",
                },
              ],
            ],
          },
        },
        {
          text: "Diagnósticos",
          style: "tableheader",
        },
        {
          unbreakable: true,
          margin: [0, 5, 0, 10],
          layout:
            data.diagnosticoCie10?.addedDiagnostics.length === 0
              ? "noBorders"
              : "headerLineOnly",
          table: {
            widths: ["auto", "*", "*", "*"],
            headerRows: 1,
            body: diagnosticsCie10FromHc(),
          },
        },
        {
          text: "Formulación Exámenes Laboratorio",
          style: "tableheader",
        },
        {
          margin: [0, 10, 0, 10],
          layout: "headerLineOnly",
          table: {
            widths: ["auto", "*", "auto", "auto"],
            headerRows: 1,
            body: labsExams(laboratoryExams),
          },
        },
        {
          margin: [0, 10, 0, 10],
          layout: "noBorders",
          table: {
            widths: ["auto", "*"],
            headerRows: 1,
            body: [
              [{ text: "OBSERVACIONES ", style: "textStyle", bold: true }, ""],
              [
                {
                  text: data.observationAndProcedure,
                  colSpan: 2,
                  style: "tableTexStyle",
                },
                "",
              ],
            ],
          },
        },
        {
          margin: [0, 50, 0, 0],
          image: await getImage(urlFirma),
          fit: [80, 80],
        },
        data.professional !== undefined && data.professional !== null
          ? {
              pageBreak: "after",
              text:
                "Dr.(a) " +
                nombres +
                " " +
                apellido1 +
                " " +
                apellido2 +
                "\n" +
                esp +
                "\n REG-" +
                reg_medico,
              style: "medicStyle",
            }
          : null
      );
    }
  }

  if (!!exams.length && !data.showClinicEvent) {
    for (let i = 0; i < exams.length; i++) {
      //body[i + 1] = [{ text: exams[i].cupscod, style: 'tableTexStyle' }, { text: exams[i].cupsnom, style: 'tableTexStyle' }];

      docContent.push(
        {
          text: "SOLICITUD DE PROCEDIMIENTOS",
          style: "tableheader",
          alignment: "center",
          margin: [0, 10, 0, 0],
        },
        {
          text:
            "Lugar y Fecha de la Prescripción: " +
            getCity[0].ciunom +
            ", " +
            format_today,
          style: "textStyle",
          margin: [0, 10, 0, 0],
        },
        {
          text:
            typeof data.third?.nombre === "undefined"
              ? ""
              : "ENTIDAD: " + data.third?.nombre,
          style: "textStyle",
          bold: true,
        },
        {
          // auto-sized columns have their widths based on their content
          margin: [0, 20, 0, 10],
          layout: "headerLineOnly",
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: [
              [
                {
                  text: "Datos del Paciente ",
                  style: "tableheader",
                  colSpan: 2,
                },
                "",
                "",
                "",
              ],
              [
                { text: "Nombre ", bold: true, style: "textStyle" },
                { text: data.names, style: "textStyle" },
                {
                  text: "Documento de Identificación: ",
                  bold: true,
                  style: "textStyle",
                },
                {
                  text: data.typeOfDocument + " " + data.documentNumber,
                  style: "textStyle",
                },
              ],
              [
                { text: "Edad ", bold: true, style: "textStyle" },
                { text: calculateAgeParse(data.birthday), style: "textStyle" },
                { text: "Genero ", bold: true, style: "textStyle" },
                { text: data.gender, style: "textStyle" },
              ],
              [
                { text: "Historia Clínica ", bold: true, style: "textStyle" },
                {
                  text:
                    data.id_historia !== undefined && data.id_historia !== null
                      ? data.id_historia
                      : "",
                  style: "textStyle",
                },
                { text: "Regimen: ", bold: true, style: "textStyle" },
                {
                  text:
                    data.regime !== undefined && data.regime !== null
                      ? data.regime
                      : "",
                  style: "textStyle",
                },
              ],
            ],
          },
        },
        {
          text: "Diagnósticos",
          style: "tableheader",
        },
        {
          unbreakable: true,
          margin: [0, 5, 0, 10],
          layout:
            data.diagnosticoCie10?.addedDiagnostics.length === 0
              ? "noBorders"
              : "headerLineOnly",
          table: {
            widths: ["auto", "*", "*", "*"],
            headerRows: 1,
            body: diagnosticsCie10FromHc(),
          },
        },
        {
          text: "Formulación Exámenes",
          style: "tableheader",
        },
        {
          margin: [0, 10, 0, 10],
          layout: "headerLineOnly",
          table: {
            widths: ["auto", "*", "auto", "auto"],
            headerRows: 1,
            body: [
              [
                { text: "CUPS ", style: "textStyle", bold: true },
                { text: "Descripción", style: "textStyle", bold: true },
                { text: "Cant.", style: "textStyle", bold: true },
                { text: "Observación", style: "textStyle", bold: true },
              ],
              [
                { text: exams[i].cupscod, style: "tableTexStyle" },
                { text: exams[i].cupsnom, style: "tableTexStyle" },
                { text: exams[i].cantidad, style: "tableTexStyle" },
                { text: exams[i].observation, style: "tableTexStyle" },
              ],
            ],
          },
        },
        {
          margin: [0, 10, 0, 10],
          layout: "noBorders",
          table: {
            widths: ["auto", "*"],
            headerRows: 1,
            body: [
              [{ text: "OBSERVACIONES ", style: "textStyle", bold: true }, ""],
              [
                {
                  text: data.observationAndProcedure,
                  colSpan: 2,
                  style: "tableTexStyle",
                },
                "",
              ],
            ],
          },
        },
        {
          margin: [0, 50, 0, 0],
          image: await getImage(urlFirma),
          fit: [80, 80],
        },
        {
          pageBreak: i + 1 === exams.length ? "after" : "after",
          text:
            "Dr.(a) " +
            nombres +
            " " +
            apellido1 +
            " " +
            apellido2 +
            "\n" +
            esp +
            "\n REG-" +
            reg_medico,
          style: "medicStyle",
        }
      );
    }
  }
  {
    const copiaHistoria = data.third.copiahistoriac === "Si" ? 2 : 1;

    for (let i = 0; i < copiaHistoria; i++) {
      if (!data.showClinicEvent) {
        docContent.push(
          {
            // auto-sized columns have their widths based on their content
            margin: [0, 5, 0, 10],
            layout: {
              defaultBorder: false,
            },
            table: {
              headerRows: 1,
              widths: ["auto", "*", "auto", "*"],
              body: [
                [
                  {
                    text: "Datos del Paciente ",
                    style: "tableheader",
                    border: [false, false, false, true],
                    colSpan: 2,
                  },
                  "",
                  {
                    text:
                      "Admisión: " + data.infoAdmission.admision?.id_admision,
                    style: "tableheader",
                    border: [false, false, false, true],
                  },
                  {
                    text:
                      "Fecha Atención: " +
                      moment(data.infoAdmission.admision?.fecha).format(
                        "DD-MM-YYYY"
                      ),
                    style: "tableheader",
                    border: [false, false, false, true],
                  },
                ],
                [
                  { text: "Nombre ", bold: true, style: "textStyle" },
                  { text: data.names, style: "textStyle" },
                  { text: "Identificación ", bold: true, style: "textStyle" },
                  {
                    text: data.typeOfDocument + "-" + data.documentNumber,
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Fecha de Nacimiento ",
                    bold: true,
                    style: "textStyle",
                  },
                  {
                    text: moment(data.birthday).format("DD-MM-YYYY"),
                    style: "textStyle",
                  },
                  { text: "Edad ", bold: true, style: "textStyle" },
                  {
                    text: calculateAgeParse(data.birthday),
                    style: "textStyle",
                  },
                ],
                [
                  { text: "Genero ", bold: true, style: "textStyle" },
                  { text: data.gender, style: "textStyle" },
                  { text: "Tipo de Sangre ", bold: true, style: "textStyle" },
                  { text: data.bloodType, style: "textStyle" },
                ],
                [
                  { text: "Dirección ", bold: true, style: "textStyle" },
                  { text: data.address, style: "textStyle" },
                  { text: "Ciudad ", bold: true, style: "textStyle" },
                  { text: data.city, style: "textStyle" },
                ],
                [
                  { text: "Estado Civil ", bold: true, style: "textStyle" },
                  { text: data.civilStatus, style: "textStyle" },
                  { text: "Tel/Cel: ", bold: true, style: "textStyle" },
                  {
                    text: data.telephone + "/" + data.cellphone,
                    style: "textStyle",
                  },
                ],
                [
                  { text: "Entidad ", bold: true, style: "textStyle" },
                  { text: data.third?.nombre, style: "textStyle" },
                  { text: "Regimen: ", bold: true, style: "textStyle" },
                  { text: data.regime, style: "textStyle" },
                ],
                [
                  { text: "Ocupación: ", bold: true, style: "textStyle" },
                  { text: data.infoAdmission?.ocupacion?.nombre ?? null, style: "textStyle" },
                  {
                    text: "Población vulnerable: ",
                    bold: true,
                    style: "textStyle",
                  },
                  { text: data.infoAdmission?.poblacion_vulnerable ?? null, style: "textStyle" },
                ],
                [
                  {
                    text: "Discapacidad: ",
                    bold: true,
                    style: "textStyle",
                  },
                  {
                    text: data.infoAdmission?.discapacidad?.discapacidad ?? null,
                    style: "textStyle",
                  },
                  data.infoAdmission?.discapacidad?.discapacidad === "Si"
                    ? {
                        text: "Tipo de Discapacidad: ",
                        bold: true,
                        style: "textStyle",
                      }
                    : null,
                  data.infoAdmission?.discapacidad?.discapacidad === "Si"
                    ? {
                        text: dataTiposDisability(),
                        style: "textStyle",
                      }
                    : null,
                ],

                ["", "", "", ""],
                ...dataLegalRepresent(),
                ...dataCompanion(),
              ],
            },
          },
          ananmnesisInformation(),
          backgroundInformation(),
          backgroundInformationHabits(),
          systemInformation(),
          physicalInformations(),
          physicalInformationBody(),
          structuredClone(diagnosticInformation(1)), //Tabla de Diagnósticos
          structuredClone(diagnosticInformation(2)), //Titulo Observaciones de diagnósticos
          structuredClone(diagnosticInformation(3)), //Observaciones de diagnósticos
          medicalPlanInformation(),
          proceduresInformations(1),
          proceduresInformations(2),
          //proceduresInformations(3),

          structuredClone(medicalOrdersInformation(1)), // titulo Formulación Exámenes
          structuredClone(medicalOrdersInformation(2)), // tablas  de ordenes y procedimientos medicos
          structuredClone(medicalOrdersInformation(3)), // titulo Observaciones de Ordenes Medica
          structuredClone(medicalOrdersInformation(4)), // texto de observaciones de oridenes medicas
          structuredClone(medicalOrdersInformation(5)), // tabla de formulas
          structuredClone(medicalOrdersInformation(6)), // titulo observaciones de formulas
          structuredClone(medicalOrdersInformation(7)), // texto observaciones de formulas

          //otherProceduresResults(),
          IncapacityInfo(),
          {
            margin: [0, 50, 0, 0],
            image: await getImage(urlFirma),
            fit: [100, 100],
          },
          {
            pageBreak:
              !!data.infoIncapacityCurrentAdmision && i == copiaHistoria - 1
                ? "after"
                : "",
            text:
              "Dr.(a) " +
              data.professional.nombres +
              " " +
              data.professional.apellido1 +
              " " +
              data.professional.apellido2 +
              "\n" +
              esp +
              "\n REG-" +
              data.professional.reg_medico,
            style: "medicStyle",
          }
        );
        if (i == 0 && copiaHistoria === 2) {
          docContent.push({ text: "", pageBreak: "before" });
        }
      }
    }
  }
  {
    !!data.showClinicEvent ? docContent.push(otherProceduresResults()) : null;
  }
  {
    !!data.infoIncapacityCurrentAdmision
      ? docContent.push(
          {
            table: {
              headerRows: 1,
              widths: [300, "auto"],
              body: [
                [
                  {
                    margin: [0, 0, 0, 0],
                    text: "",
                    style: "tableheader",
                  },
                  {
                    margin: [0, 0, 0, 0],
                    text:
                      "INCAPACIDAD - ENFERMEDAD GENERAL " +
                      "No. " +
                      data.infoIncapacityCurrentAdmision[0]
                        ?.id_hist_incapacidad,
                    style: "tableheader",
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
          {
            // auto-sized columns have their widths based on their content
            margin: [0, 5, 0, 10],
            layout: "headerLineOnly",
            table: {
              headerRows: 1,
              widths: ["auto", "*", "auto", "*"],
              body: [
                [
                  { text: "Datos del Paciente ", style: "tableheader" },
                  "",
                  "",
                  {
                    text:
                      "Fecha Atención: " +
                      moment(data.infoAdmission.admision?.fecha).format(
                        "DD-MM-YYYY"
                      ),
                    style: "tableheader",
                  },
                ],
                [
                  {
                    text: "Tipo de Documento ",
                    bold: true,
                    style: "textStyle",
                  },
                  { text: data.typeOfDocument, style: "textStyle" },
                  { text: "No. Documento", bold: true, style: "textStyle" },
                  { text: data.documentNumber, style: "textStyle" },
                ],
                [
                  { text: "Nombre ", bold: true, style: "textStyle" },
                  { text: data.names, style: "textStyle" },
                  {
                    text: "Fecha de Nacimiento ",
                    bold: true,
                    style: "textStyle",
                  },
                  {
                    text: moment(data.birthday).format("DD-MM-YYYY"),
                    style: "textStyle",
                  },
                ],
                [
                  { text: "Edad ", bold: true, style: "textStyle" },
                  {
                    text: calculateAgeParse(data.birthday),
                    style: "textStyle",
                  },
                  { text: "Genero ", bold: true, style: "textStyle" },
                  { text: data.gender, style: "textStyle" },
                ],
                [
                  { text: "Dirección ", bold: true, style: "textStyle" },
                  { text: data.address, style: "textStyle" },
                  { text: "Ciudad ", bold: true, style: "textStyle" },
                  { text: data.city, style: "textStyle" },
                ],
                [
                  { text: "Télefono ", bold: true, style: "textStyle" },
                  { text: data.telephone, style: "textStyle" },
                  { text: "Celular ", bold: true, style: "textStyle" },
                  { text: data.cellphone, style: "textStyle" },
                ],
                [
                  { text: "Estado Civil ", bold: true, style: "textStyle" },
                  { text: data.civilStatus, style: "textStyle" },
                  { text: "Tipo de Sangre ", bold: true, style: "textStyle" },
                  { text: data.bloodType, style: "textStyle" },
                ],
              ],
            },
          },
          {
            table: {
              headerRows: 1,
              widths: [520],
              body: [[""], [""]],
            },
            layout: "headerLineOnly",
          },
          data.infoIncapacityCurrentAdmision !== null
            ? {
                unbreakable: true,
                margin: [0, 5, 0, 10],
                layout: "noBorders",
                table: {
                  widths: ["auto", "*", "auto", "*"],
                  headerRows: 1,
                  body: [
                    [
                      {
                        text: "Días de incapacidad: ",
                        style: "textStyle",
                        bold: true,
                        alignment: "rigth",
                      },
                      {
                        text: data.infoIncapacityCurrentAdmision[0]
                          ?.dias_incapacidad,
                        style: "textStyle",
                        alignment: "rigth",
                      },
                      {
                        text:
                          "Fecha de inicio: " +
                          moment(
                            data.infoIncapacityCurrentAdmision[0]?.fecha_incial
                          ).format("DD-MM-YYYY"),
                        style: "textStyle",
                        bold: true,
                        alignment: "left",
                      },
                      {
                        text:
                          "Fecha en la que termina: " +
                          moment(
                            data.infoIncapacityCurrentAdmision[0]?.fecha_final
                          ).format("DD-MM-YYYY"),
                        style: "textStyle",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                  ],
                },
              }
            : null,
          {
            text: "Diagnóticos que generan la incapacidad",
            style: "textStyle",
            bold: true,
          },
          {
            unbreakable: true,
            margin: [0, 5, 0, 10],
            layout:
              data.diagnosticoCie10?.addedDiagnostics.length === 0
                ? "noBorders"
                : "headerLineOnly",
            table: {
              widths: ["auto", "*", "*", "*"],
              headerRows: 1,
              body: diagnosticsCie10FromHc(),
            },
          },
          data.infoIncapacityCurrentAdmision !== null
            ? {
                unbreakable: true,
                margin: [0, 5, 0, 10],
                layout: "noBorders",
                table: {
                  widths: ["auto", "*"],
                  headerRows: 1,
                  body: [
                    [
                      {
                        text: "Observaciones: ",
                        style: "textStyle",
                        bold: true,
                      },
                      {
                        text: data.infoIncapacityCurrentAdmision[0]
                          ?.observaciones,
                        style: "textStyle",
                      },
                    ],
                  ],
                },
              }
            : null,
          {
            margin: [0, 50, 0, 0],
            image: await getImage(urlFirma),
            fit: [80, 80],
          },
          {
            text:
              "Dr.(a) " +
              data.professional.nombres +
              " " +
              data.professional.apellido1 +
              " " +
              data.professional.apellido2 +
              "\n" +
              esp +
              "\n REG-" +
              data.professional.reg_medico,
            style: "medicStyle",
          }
        )
      : null;
  }

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [20, 50, 20, 20],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              { text: name, style: "head" },
              { text: "Fecha Impresión: " + fecha, style: "head" },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 0, 5],
      };
    },
    content: docContent,
    styles: {
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      textStyle: {
        fontSize: 9,
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        margin: [0, 10, 0, 0],
        fontSize: 9,
        alignment: "left",
        font: "OpenSans",
        bold: true,
      },
      tableText: {
        fontSize: 9,
        font: "OpenSans",
      },
      textStylePatientInfo: {
        fontSize: 8,
        font: "OpenSans",
      },
      tableheaderPatient: {
        fontSize: 8,
        font: "OpenSans",
        bold: true,
      },
      textRepresentandCompanion: {
        fontSize: 10,
      },
    },
  };

  pdfMake.createPdf(documentDefinition).open();
  /* if(data.from === 'IMP'){
        const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
        pdfDocGenerator.getDataUrl(function (outDoc) {
            document.getElementById('pdfV').src = outDoc;
        });
    }else{
        pdfMake.createPdf(documentDefinition).open();
    } */
};
export default proceduresAndMedicinesPDF;
